<template>
  <component
    :is="baseComponent"
    :to="link.path ? link.path : '/'"
    tag="a"
    class="router-table"
  >
    <slot
      name="title"
      v-if="children.length === 0 && !$slots.default && link.path"
    >
      <component
        :to="link.path"
        :is="elementType(link, false)"
        :class="{ active: link.active }"
        :target="link.target"
        :href="link.path"
      >
        <template v-if="addLink">
          <span>{{ linkPrefix }}</span>
          <span>{{ link.name }}</span>
        </template>
        <template v-else>
          <i :class="link.icon"></i>
          <p>{{ link.name }}</p>
        </template>
      </component>
    </slot>
  </component>
</template>

<script>
export default {
  name: "router-table",

  props: {
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          children: [],
        };
      },
      description:
        "Sidebar link. Can contain name, path, icon and other attributes. See examples for more info",
    },
  },
  provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild,
    };
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null },
  },
  data() {
    return {
      children: [],
    };
  },
  computed: {
    baseComponent() {
      return this.isMenu || this.link.isRoute ? "div" : "router-link";
    },
    linkPrefix() {
      if (this.link.name) {
        let words = this.link.name.split(" ");
        return words.map((word) => word.substring(0, 1)).join("");
      }
    },
  },
  methods: {
    addChild(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild(item) {
      const tabs = this.children;
      const index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType(link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? "li" : "a";
      } else {
        return "router-link";
      }
    },
    linkAbbreviation(name) {
      const matches = name.match(/\b(\w)/g);
      return matches.join("");
    },
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  },
};
</script>
<style scoped>
.router-table {
  padding: 10px;
  margin: 5px;
  background-color: #363636;
  border-radius: 5px;
  min-width: 150px;
  min-height: 70px;
  font-size: 1.1rem;
}

.router-table:hover {
  background-color: #575757;
}
.router-table:focus {
  background-color: #575757;
}

.router-table:target {
  background-color: #575757;
}

a {
  color: #ffffff !important;
}
a:hover {
  color: #ffffff !important;
}
.a:active {
  background-color: #ffffff !important;
}

.card-route-mobile {
  font-size: 2.2rem;
  height: 8rem;
  width: 15rem;
}
</style>
